<template>
    <div class="h-full flex flex-col rounded-lg overflow-hidden cursor-pointer border border-gray-200 hover:border-gray-400 hover:shadow-md bg-white transition-all duration-200" @click="open(link)">
        <div class="px-3 py-2 border-b border-gray-100">
            <div class="flex items-center gap-2 text-gray-700">
                <div class="text-gray-400">
                    <component v-if="icon" :is="icon" class="inline-block w-4 h-4" aria-hidden="true" />
                </div>
                <div class="font-medium text-sm">{{ title }}</div>
            </div>
        </div>
        <div class="px-3 py-2.5 text-gray-500 text-xs leading-relaxed flex-1">
            {{ description }}
        </div>
    </div>
</template>

<script>

import {
    LinkIcon,
    CheckBadgeIcon,
    EnvelopeIcon,
    InboxArrowDownIcon,
    ChatBubbleBottomCenterIcon,
    TagIcon,
    CreditCardIcon,
} from '@heroicons/vue/24/outline'    
    

import Lock from "_app/resources/components/cruds/icons/Lock.vue";
import Users from "_app/resources/components/cruds/icons/Users.vue";
import Workspace from "_app/resources/components/cruds/icons/Workspace.vue";
import Helpdesk from "_app/resources/components/cruds/icons/Helpdesk.vue";
import Form from "_app/resources/components/cruds/icons/Form.vue";
import Inbox from "_app/resources/components/cruds/icons/Inbox.vue";

    export default {
        name: "CardDashboard",

        props:{

            title: {
                type: String,
                default: 'title',
                required: false
            },
            description: {
                type: String,
                default: '',
                required: false
            },

            icon: {
                type: String,
                default: '',
                required: false
            },

            link: {
                type: String,
                default: '',
                required: false
            },

        },

        data() {
            return {
               
            }
        },

        methods: {
            open(route) {
                this.$router.push(route);
            },
        },

        components: {
            LinkIcon,
            Lock,
            Users,
            Workspace,
            Helpdesk,
            Form,
            EnvelopeIcon,
            InboxArrowDownIcon,
            Inbox,
            CheckBadgeIcon,
            ChatBubbleBottomCenterIcon,
            TagIcon,
            CreditCard: CreditCardIcon,

        }
    }
    </script>
    